import BackIcon from '@mui/icons-material/ArrowBack';
import PropTypes from 'prop-types';
import React from 'react';
import {Box, Button, Grid, Divider as MuiDivider, styled} from '@mui/material';
import {Stroke, Style} from 'ol/style';
import {fill, scale} from '../util/styles.js';
import {getClassColorLookup} from '../util/feed.js';

export const RejectButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.error.main,
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
    border: 'none',
  },
  border: 'none',
  width: '100%',
}));

export const KeepButton = styled(RejectButton)(({theme}) => ({
  backgroundColor: theme.palette.success.main,
  '&:hover': {
    backgroundColor: theme.palette.success.dark,
    border: 'none',
  },
}));

const ToolbarButton = styled(Button)(({theme}) => ({
  margin: theme.spacing(1),
}));

export const Toolbar = ({backDisabled, onBack, onClose}) => (
  <Grid container>
    <Grid item xs={6}>
      <ToolbarButton
        disabled={backDisabled}
        onClick={() => onBack()}
        startIcon={<BackIcon />}
      >
        Previous detect
      </ToolbarButton>
    </Grid>
    <Grid item xs={6} align="right">
      <ToolbarButton onClick={() => onClose()}>Exit</ToolbarButton>
    </Grid>
  </Grid>
);

Toolbar.propTypes = {
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  backDisabled: PropTypes.bool,
};

export const ExportLink = styled('span')(({theme}) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  textDecoration: 'underline',
  textDecorationColor: theme.palette.primary.main,
  padding: 2,
  cursor: 'pointer',
}));

const sharedStyle = new Style({
  stroke: new Stroke({
    color: 'white',
    width: 2,
  }),
  fill,
});

/**
 * @param {Object} [feed] A feed object.  If the feed has an `outputClasses` property, it will be used to lookup colors.
 * @return {function(Feature): Style} A style funciton.
 */
export function featureStyle(feed) {
  const classColorLookup = getClassColorLookup(feed);
  return function (feature) {
    const score = feature.get('score') || 1;
    let color;
    if (classColorLookup) {
      const classLabel = feature.get('object_class_label');
      if (classLabel in classColorLookup) {
        color = classColorLookup[classLabel];
      }
      color = classColorLookup[classLabel];
    }
    if (!color) {
      color = scale(score).hex();
    }

    sharedStyle.getStroke().setColor(color);
    return sharedStyle;
  };
}

export const Divider = styled(MuiDivider)(({theme}) => ({
  backgroundColor: theme.palette.grey[900],
  height: 2,
}));

export const MapParent = styled(Box)(({theme}) => ({
  position: 'relative',
  flex: 1,
  margin: '20px',
  borderRadius: '20px',
  overflow: 'hidden',
  backgroundColor: theme.palette.grey[600],
}));
